import { useInfiniteQuery } from '@tanstack/react-query';
import { monitoringFilterApi } from '~/apis';
import { QueryKeyDetected } from '~/apis/detection';
import { parseDropDown } from '~/utils';
import { MonitoringFilterProtocolPagingRequest } from '~/swagger/data-contracts';

export const OFFICIAL_IMAGE_FILTER_LIMIT = 30;

export const useGetAllOIQuery = (request: MonitoringFilterProtocolPagingRequest) => {
  return useInfiniteQuery(
    [QueryKeyDetected, 'get-all-ois', request],
    async ({ pageParam }) => {
      const { data } = await monitoringFilterApi.filterGetAllOisCreate({
        ...request,
        search_after: pageParam || request.search_after,
      });
      return data;
    },
    {
      select: (data) => {
        return {
          pageParams: data.pageParams,
          pages: data.pages.map((page) => parseDropDown<number>(page)),
        };
      },
      getNextPageParam: (lastPage) => {
        if (lastPage.list.length < OFFICIAL_IMAGE_FILTER_LIMIT) {
          return;
        }

        return lastPage.search_after;
      },
      enabled: !!request.channel_type,
    }
  );
};
